import { AppConfig, ModalItem, NotificationItem } from '@/models/AppConfig';
import { MutationTree } from 'vuex';

export const ConfigMutations = {
	REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
	ADD_NOTIFICATION: 'ADD_NOTIFICATION',
	UPDATE_HTTP_PROGRESS_INDICATOR: 'UPDATE_HTTP_PROGRESS_INDICATOR',
	REMOVE_MODAL: "REMOVE_MODAL",
	ADD_MODAL: "ADD_MODAL",
	CHANGE_MODAL_SHOW: "CHANGE_MODAL_SHOW"
};

export const mutations: MutationTree<any> = {
	[ConfigMutations.REMOVE_NOTIFICATION] (state: AppConfig, payload: NotificationItem) {
		state.notifications = state.notifications.filter((notification: NotificationItem) => notification.uuid !== payload.uuid);
	},
	[ConfigMutations.ADD_NOTIFICATION] (state: AppConfig, payload: NotificationItem) {
		state.notifications.push(payload);
	},
	[ConfigMutations.UPDATE_HTTP_PROGRESS_INDICATOR]: (state: AppConfig, payload: boolean) => {
		state.httpInProgress = state.httpInProgress = payload;
	},
	[ConfigMutations.REMOVE_MODAL]: (state: AppConfig, payload: Partial<ModalItem>) => {
		const removeIndex = state.modals.findIndex((modal: ModalItem) => modal.uuid === payload.uuid);
		if (removeIndex >= 0) {
			state.modals.splice(removeIndex, 1);
		}
	},
	[ConfigMutations.ADD_MODAL]: (state: AppConfig, payload: ModalItem) => {
		state.modals.push(payload);
	},
	[ConfigMutations.CHANGE_MODAL_SHOW]: (state: AppConfig, payload: { uuid: string, show: boolean }) => {
		const modalIndex = state.modals.findIndex((modal: ModalItem) => modal.uuid === payload.uuid);
		if (modalIndex > -1) {
			state.modals[modalIndex].show = payload.show
		}
	}
}
